export function applyBulletToggle(text: string, start: number, end: number): { newText: string; newCursorPos: number } {
  const beforeCursor = text.substring(0, start);
  const lineStart = beforeCursor.lastIndexOf('\n') + 1;
  const lineEnd = text.indexOf('\n', end);
  const currentLine = text.substring(lineStart, lineEnd === -1 ? text.length : lineEnd);

  const hasBullet = /^[•*\-]\s/.test(currentLine);

  if (hasBullet) {
    const bulletMatch = currentLine.match(/^([•*\-]\s*)/);
    const prefixLength = bulletMatch ? bulletMatch[1].length : 0;
    const cleanedLine = currentLine.substring(prefixLength);
    const newText = text.substring(0, lineStart) + cleanedLine + text.substring(lineEnd === -1 ? text.length : lineEnd);
    const newCursorPos = Math.max(lineStart, start - prefixLength);
    return { newText, newCursorPos };
  } else {
    const cleanedLine = currentLine.replace(/^\d+\.\s*/, '').trimStart();
    const bulletedLine = `• ${cleanedLine}`;
    const newText = text.substring(0, lineStart) + bulletedLine + text.substring(lineEnd === -1 ? text.length : lineEnd);
    const offsetInLine = start - lineStart;
    const bulletPrefixLength = 2;
    const newCursorPos = lineStart + bulletPrefixLength + Math.max(0, offsetInLine);
    return { newText, newCursorPos };
  }
}

export function applyNumberingToggle(text: string, start: number, end: number): { newText: string; newCursorPos: number } {
  const beforeCursor = text.substring(0, start);
  const lineStart = beforeCursor.lastIndexOf('\n') + 1;
  const lineEnd = text.indexOf('\n', end);
  const currentLine = text.substring(lineStart, lineEnd === -1 ? text.length : lineEnd);

  const hasNumbering = /^\d+\.\s/.test(currentLine);

  if (hasNumbering) {
    const numberMatch = currentLine.match(/^(\d+\.\s*)/);
    const prefixLength = numberMatch ? numberMatch[1].length : 0;
    const cleanedLine = currentLine.substring(prefixLength);
    const newText = text.substring(0, lineStart) + cleanedLine + text.substring(lineEnd === -1 ? text.length : lineEnd);
    const newCursorPos = Math.max(lineStart, start - prefixLength);
    return { newText, newCursorPos };
  } else {
    const lines = text.split('\n');
    let maxNumber = 0;
    for (const line of lines) {
      const match = line.match(/^(\d+)\.\s/);
      if (match) {
        const num = parseInt(match[1], 10);
        if (num > maxNumber) maxNumber = num;
      }
    }
    const nextNumber = maxNumber + 1;
    const cleanedLine = currentLine.replace(/^[•*\-]\s*/, '').trimStart();
    const numberedLine = `${nextNumber}. ${cleanedLine}`;
    const newText = text.substring(0, lineStart) + numberedLine + text.substring(lineEnd === -1 ? text.length : lineEnd);
    const offsetInLine = start - lineStart;
    const numberPrefixLength = `${nextNumber}. `.length;
    const newCursorPos = lineStart + numberPrefixLength + Math.max(0, offsetInLine);
    return { newText, newCursorPos };
  }
}

export function handleListKeyDownLogic(
  text: string,
  start: number,
  end: number,
  key: string
): { handled: boolean; newText?: string; newCursorPos?: number } {
  if (key === 'Enter') {
    const beforeCursor = text.substring(0, start);
    const lines = beforeCursor.split('\n');
    const currentLine = lines[lines.length - 1];
    const bulletMatch = currentLine.match(/^([•*\-]\s)/);
    const numberMatch = currentLine.match(/^(\d+\.\s)/);

    if (bulletMatch) {
      const bulletPrefix = bulletMatch[1];
      const newText = text.substring(0, start) + '\n' + bulletPrefix + text.substring(end);
      const newCursorPos = start + 1 + bulletPrefix.length;
      return { handled: true, newText, newCursorPos };
    }
    if (numberMatch) {
      const currentNumber = parseInt(numberMatch[1].replace(/\.\s*$/, ''), 10);
      const nextNumber = currentNumber + 1;
      const numberPrefix = `${nextNumber}. `;
      const newText = text.substring(0, start) + '\n' + numberPrefix + text.substring(end);
      const newCursorPos = start + 1 + numberPrefix.length;
      return { handled: true, newText, newCursorPos };
    }
    const newText = text.substring(0, start) + '\n' + text.substring(end);
    const newCursorPos = start + 1;
    return { handled: true, newText, newCursorPos };
  }

  if (key === 'Backspace' && start === end && start > 0) {
    const beforeCursor = text.substring(0, start);
    const lineStart = beforeCursor.lastIndexOf('\n') + 1;
    const lineEnd = text.indexOf('\n', start);
    const fullLine = text.substring(lineStart, lineEnd === -1 ? text.length : lineEnd);
    const bulletMatch = fullLine.match(/^([•*\-]\s)/);
    const numberMatch = fullLine.match(/^(\d+\.\s)/);
    const bulletPrefixLength = bulletMatch ? bulletMatch[1].length : 0;
    const numberPrefixLength = numberMatch ? numberMatch[1].length : 0;
    const prefixLength = bulletPrefixLength || numberPrefixLength;
    if (prefixLength > 0 && start === lineStart + prefixLength) {
      const newText = text.substring(0, lineStart) + text.substring(lineStart + prefixLength);
      return { handled: true, newText, newCursorPos: lineStart };
    }
  }

  return { handled: false };
}


